import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../FontAwesomeIcons";
import moment from "moment";
import './VideoMessage.css';

export class VideoMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mediaUrl: null,
            shouldAutoplay: false,
        };
        this.videoRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.mediaUrl && this.state.mediaUrl !== prevState.mediaUrl && this.videoRef.current) {
            const video = this.videoRef.current;
            video.load();
            if (this.state.shouldAutoplay) {
                const playPromise = video.play();
                if (playPromise?.catch) playPromise.catch(() => {});
                this.setState({shouldAutoplay: false});
            }
        }
    }

    handleLoadVideo = () => {
        if (this.state.mediaUrl) return;
        const mediaUrl = this.props.getMediaContentUrlAPI(this.props.messageData.id_messaggio);
        this.setState({mediaUrl, shouldAutoplay: true});
    }

    render() {
        const {isMine, messageData} = this.props;
        const {mediaUrl} = this.state;
        const sendTime = moment(messageData.data_creazione).format('HH:mm');

        const videoStyle = {
            maxWidth: 300,
            borderRadius: 15
        };

        const placeholderStyle = {
            ...videoStyle,
            backgroundColor: '#f0f0f0',
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid rgba(0,0,0,0.1)',
            boxShadow: 'inset 0 0 20px rgba(0,0,0,0.08)'
        };

        const overlayStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease-in-out'
        };

        return (
            <React.Fragment>
                {
                    mediaUrl ?
                        <div>
                            <video
                                ref={this.videoRef}
                                className={"mb-2"}
                                controls={true}
                                style={videoStyle}
                                preload={"none"}
                            >
                                <source src={mediaUrl} type={messageData.metadata.mime_type}/>
                                Your browser does not support the video element.
                            </video>
                        </div>
                        :
                        <div className={"mb-2 video-placeholder"} style={placeholderStyle}>
                            <div className={"video-placeholder-inner"}>
                                <div
                                    style={overlayStyle}
                                    className={"video-placeholder-overlay"}
                                    onClick={this.handleLoadVideo}
                                >
                                    <span className={"video-placeholder-button"}>
                                        <FaSolidIcon name={"play"} />
                                    </span>
                                </div>
                            </div>
                        </div>
                }
                <div className={"metadata"}>
                    {sendTime}&nbsp;
                    {
                        isMine &&
                        <FaSolidIcon name={messageData.letto === '1' ? 'check-double' : 'check'}/>
                    }
                </div>
            </React.Fragment>
        );
    }
}

VideoMessage.propTypes = {
    isMine: PropTypes.bool,
    messageData: PropTypes.object.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
};

